export default {
  UPDATE_EVENTS (state, payload) {
    state.events = payload
  },
  UPDATE_LANG (state, payload) {
    state.lang = payload
  },
  UPDATE_CONTENT (state, payload) {
    state.content = payload
  },
  SET_SEARCH_TERM (state, payload) {
    state.searchTerm = payload
  },
  SET_SEARCH_RESULTS (state, payload) {
    state.searchResults = payload
  }
}
